import React from 'react';

import { Button } from '@BICE_Vida/components';

import { Modal, ModalBody, ModalContent } from '@BICE_Vida/scp-components';

import { CAT } from '@/utils/assets';

import styles from './TelemedicineModal.module.scss';
import { landingText } from '@/utils/generalTexts';
import Alert from '@/designSystem/Alert';

type TelemedicineModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

function TelemedicineModal({ isOpen, setIsOpen }: TelemedicineModalProps) {
  const onClickFunction = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClickFunction} closeOnOverlay classNameModal={styles.modal}>
      <ModalBody
        img={CAT.CAT_DOCTOR}
        className={styles.modal_body}
        content={
          <ModalContent
            title={landingText.hero.telemedicineModal.title}
            className={styles.text_modal_content}
          >
            <div className={styles.text_modal_body}>{landingText.hero.telemedicineModal.body}</div>

            <Alert
              text={landingText.hero.telemedicineModal.alert}
              customClass={styles.alert_requirements}
            />
          </ModalContent>
        }
      />
      <div className={styles.container_buttons}>
        <Button
          text={landingText.hero.modal.button}
          variant="primary"
          size="large"
          onClick={onClickFunction}
        />
      </div>
    </Modal>
  );
}

export default TelemedicineModal;
